import { render, staticRenderFns } from "./chart_prs.vue?vue&type=template&id=1a50845e&scoped=true"
import script from "./chart_prs.vue?vue&type=script&lang=ts"
export * from "./chart_prs.vue?vue&type=script&lang=ts"
import style0 from "./chart_prs.vue?vue&type=style&index=0&id=1a50845e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a50845e",
  null
  
)

export default component.exports